
import api               from '@/api'
export default {
  
    methods: {
        async getSaleData(saleId)
        {
          
          const sp         = {'sp'     : 'spFiscalReceiptSaleData'}
          const data       = {'saleId' : saleId }
          const json       = Object.assign(data, sp)
          return new Promise( async (resolve, reject)  =>  {  
          await api.post(json).then(res => {
    
            if(res.status == 200)
            {
              
                resolve(res.data.recordsets)                
                        
            }
            else if(res.status==500)
              {
                console.log(res.data)
                resolve([])
              }
              else
              {
                resolve([])
                console.log(res)
                
              } 
    
            })
            .catch(err => 
          {
            resolve([])
            console.log(err.message)
          }).finally(() => {
            
           
          });

        }) 
        },
      
         
    }

}